///
/// EarthBrowser
///
/// Created by Matt Giger on 2/2/2025
/// Copyright (c) 2025 Geodata Labs
///

import { Renderer } from "@stovokor/engine/Renderer"
import { RenderState } from "@stovokor/engine/RenderState"
import { type matrix } from "@stovokor/math/matrix"
import { type vec3 } from "@stovokor/math/vector"
import { type Geometry } from "@stovokor/shader/Geometry"
import { type ShaderSourceDefinition } from "@stovokor/shader/ShaderSourceCode"
import { UniformDynamic } from "@stovokor/shader/Uniform"
import { type GLTFMaterial } from "./GLTFMaterial"
import { type StovokorContext } from "@stovokor/StovokorContext"

export class GLTFRenderer extends Renderer {
	public modelMatrix = new UniformDynamic<matrix>()
	public viewMatrix = new UniformDynamic<matrix>()
	public projectionMatrix = new UniformDynamic<matrix>()
	// public jointTransform?: Uniform<matrix[]>
	public cameraPosition = new UniformDynamic<vec3>()
	public lightDirection = new UniformDynamic<vec3>()

	constructor(context: StovokorContext, source: ShaderSourceDefinition, model: Geometry, material: GLTFMaterial) {
		super(context, source, model, [material])

		// Respect the material's doubleSided property per glTF spec
		// If doubleSided is true, disable backface culling
		if(material.doubleSided) {
			this.drawState.cullFace = false
		}
		// Otherwise, backface culling remains enabled (default WebGL behavior)
	}

	protected stateUpdate(state: RenderState): void {
		this.modelMatrix.value = state.modelMatrix
		this.viewMatrix.value = state.viewMatrix
		this.projectionMatrix.value = state.projection
		this.cameraPosition.value = state.camera.position
		this.lightDirection.value = RenderState.lightDirection
	}

	override setupRenderActions(): void {
		super.setupRenderActions()
	}
}
